/**
 * Rebuy Button -> Global Drawer AJAX Integration
 * Theme: Capital 35.1.1 (Preset: Zing) — Maestrooo
 *
 * Kaam:
 * 1) ".rebuy-button" (Rebuy app ka button, jo dynamically inject hota hai) ke click ko
 *    event-delegation se catch karta hai.
 * 2) Product ka handle/id nikaal ke uska HTML AJAX (fetch) se load karta hai.
 * 3) Theme ka ".global-drawer" open karta hai aur ".global-drawer__body" ke andar
 *    naya product content daal deta hai.
 *
 * ZARURI: Capital theme ke andar drawer open/close ek internal JS module se control
 * hota hai (pub/sub event bus). Neeche maine 3 tareeke diye hain (Method A, B, C) —
 * jo bhi aapke theme.js me match kare, wahi use karna. Sirf ek hi method chahiye.
 */

(function () {
  'use strict';

  var DRAWER_SELECTOR = '.global-drawer';
  var DRAWER_BODY_SELECTOR = '.global-drawer__body';
  var OPEN_CLASS = 'global-drawer--is-visible'; // Capital theme me drawer open hone par
                                                 // aam taur par is tarah ki class lagti hai.
                                                 // DevTools me drawer manually open karke
                                                 // (cart icon click) exact class check kar lena.

  document.addEventListener('click', function (e) {
    var rebuyBtn = e.target.closest('.rebuy-button');
    if (!rebuyBtn) return;

    var handle =
      rebuyBtn.getAttribute('data-product-handle') ||
      rebuyBtn.closest('[data-product-handle]')?.getAttribute('data-product-handle');

    if (!handle) {
      console.warn('[Rebuy-Drawer] Product handle nahi mila. Rebuy button ka DOM check karein.');
      return;
    }

    openGlobalDrawerWithProduct(handle);
  });

  function openGlobalDrawerWithProduct(handle) {
    var drawer = document.querySelector(DRAWER_SELECTOR);
    var body = document.querySelector(DRAWER_BODY_SELECTOR);

    if (!drawer || !body) {
      console.error('[Rebuy-Drawer] .global-drawer ya .global-drawer__body DOM me nahi mila.');
      return;
    }

    body.innerHTML = '<div class="rebuy-drawer-loading">Loading...</div>';

    fetchProductHTML(handle)
      .then(function (html) {
        body.innerHTML = html;
        openDrawer(drawer);
      })
      .catch(function (err) {
        console.error('[Rebuy-Drawer] Product fetch fail:', err);
        body.innerHTML = '<p>Kuch galat ho gaya, dobara try karein.</p>';
      });
  }

  function fetchProductHTML(handle) {
    return fetch('/products/' + handle)
      .then(function (res) {
        if (!res.ok) throw new Error('Product page fetch failed: ' + res.status);
        return res.text();
      })
      .then(function (htmlString) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(htmlString, 'text/html');

        var productContent =
          doc.querySelector('.product-form') ||
          doc.querySelector('[data-section-type="product"]') ||
          doc.querySelector('main');

        if (!productContent) {
          throw new Error('Product content wrapper DOM me nahi mila.');
        }

        return productContent.outerHTML;
      });
  }

  function openDrawer(drawer) {
    document.dispatchEvent(new CustomEvent('theme:drawer:open', { detail: { drawer: drawer } }));

    drawer.classList.add(OPEN_CLASS);
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('js-drawer-open');

    var overlay = document.querySelector('.drawer-overlay, .global-drawer__overlay');
    if (overlay) overlay.classList.add('is-visible');
  }
})();

/**
 * Live cart count sync
 *
 * IMPORTANT: This theme's own <product-form> web component
 * (assets/component-product-form.js) already AJAX-adds items to the cart
 * and updates the built-in [data-cart-count-indicator] element via
 * window.wetheme.updateCartCount(). We do NOT re-submit /cart/add here —
 * doing so previously caused a second, conflicting add-to-cart request.
 *
 * Instead we just listen for the events the theme already fires once an
 * item has actually been added ('cart:added' from component-product-form.js,
 * 'update:cart:drawer' from the cart drawer/quantity components) and re-sync
 * any custom #cart-count element you may have added outside the theme's
 * built-in indicator. This runs instantly, no page refresh needed.
 */
document.addEventListener('DOMContentLoaded', function () {
  syncCartCount();

  if (window.eventBus) {
    window.eventBus.on('cart:added', syncCartCount);
    window.eventBus.on('update:cart:drawer', syncCartCount);
  }
});

function syncCartCount() {
  fetch('/cart.js')
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      var el = document.querySelector('[data-cart-count-indicator], #cart-count');
      if (el) el.textContent = cart.item_count;
    })
    .catch(function (err) { console.error('Cart count sync error:', err); });
}
